import { render } from "./AverageBarChart.vue?vue&type=template&id=60599c75"
import script from "./AverageBarChart.vue?vue&type=script&lang=js"
export * from "./AverageBarChart.vue?vue&type=script&lang=js"
script.render = render

export default script